import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  baseUrl = environment.baseUrl;
  token = 'Jamesbond_007';
  constructor(private socket: Socket, private http: HttpClient) { }

  public socketConnection() {
    this.socket.emit('bigboyget', {
      token: this.token,      
    });
    console.log(this.token,'connection');

  }  
  private getAuthHeaders(): HttpHeaders {
      const token = localStorage.getItem('token');
      return new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
    }

  public getSocketMessages = ()=>{
    return Observable.create((observer)=>{
      this.socket.on(this.token, (message)=>{
        observer.next(message);
        observer.complete();

      });
    });
  }  
  public getSocketChatMessages = ()=>{
    return Observable.create((observer)=>{
      this.socket.on(this.token, (message)=>{
        observer.next(message);
      });
    });
  }
  public removeSocketConnection=()=>{
    return this.socket.removeAllListeners()
  }
  // sendMessage(msg:any){
  //   return this.http.post(`${this.baseUrl}/api/sellers/setChat`, msg ,{ headers: this.getAuthHeaders() });
  // }
  // getMessages(chat:any){
  //   return this.http.get(`${this.baseUrl}/api/sellers/getChat?receiver_id=${chat.receiver_id}&sender_id=${chat.sender_id}&content_id=${chat.content_id}`)
  // }

  sendMessage(msg: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/sellers/setChat`, msg, {
      headers: this.getAuthHeaders()
    });
  }

  getMessages(chat: any): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/sellers/getChat?receiver_id=${chat.receiver_id}&sender_id=${chat.sender_id}&content_id=${chat.content_id}`,
      { headers: this.getAuthHeaders() } // ✅ Add headers here
    );
  }
   
}
